import {collection, addDoc, setDoc, getDocs, updateDoc, deleteDoc, doc} from "firebase/firestore";
import React, { useRef, useState } from 'react';
import { useForm } from "react-hook-form";
import { db } from './firebase-config'
import {v4 as uuidv4} from "uuid"


function App() {

  const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
    mode: 'onChange',
    defaultValues: "",
})

  const [validation, setValidation] = useState("")  

  const onSubmit = async data => {
      
    var entreprise = ["/"];     
    var nom = "/";     
    var prenom = "/";     
    var poste = "/";
  
  if(data.nom) {
    nom = data.nom
  }
  
  if(data.prenom) {
    prenom = data.prenom
  }
  
  if(data.entreprise) {
    entreprise = data.entreprise
  }
  
  if(data.poste) {
    poste = data.poste
  }
  
  try {
  
    const preSubInfo = {
      ID: uuidv4(), 
      ENTREPRISE: entreprise,
      NOM: nom,
      PRENOM: prenom,
      POSTE: poste,     
    }

    console.log(preSubInfo)
    console.log(data)
    const ref = collection(db, "msInnovSignIn");
    const docRef = addDoc(ref, preSubInfo)
    setValidation(["Vos réponses ont bien été enregistrées !", "Success"])
  
  }
          catch(err) {
          console.log(err);
          setValidation(["Une erreur s'est produite veuillez rééssayer ultérieurement", "Error"])
      }
  
      formRef.current.reset();
      window.scrollTo(550, 500)
  
      
  
  
  }


  const formRef = useRef()

  return (
    <div className="App">

      <div className="header">
        <h1>Le TECHN'HOM se <span className="mobi">Mobi</span>lise</h1> 
        <h2 className="date">VENDREDI 15 SEPTEMBRE 2023</h2>
        <h2 className="heure">De 14h à 16h</h2>
        <h3>Parlons <span>mobilité</span> et <span>covoiturage</span> !</h3>
        <h4>Inscriptions jusqu'au mercredi 13 septembre</h4>
      </div>
      
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
      {validation && <div className={ validation[1] === "Success" ? "success" : validation === "Error" ? "error" : "none"}>{validation[0]}</div> }
        <div className="formContent">

        <label htmlFor="nom">Nom</label>
        <input {...register("nom")} type="text" name="nom" />
        <label htmlFor="prenom">Prénom</label>
        <input {...register("prenom")} type="text" name="prenom" />
        <label htmlFor="entreprise">Entreprise</label>
        <input {...register("entreprise")} type="text" name="entreprise" />
        <label htmlFor="poste">Intitulé du poste (facultatif)</label>
        <input {...register("poste")} type="text" name="poste"/>

        <button>Envoyer</button>
       </div>
      </form>
      <div className="info">
      <h4>L’évènement se déroula dans les locaux de :</h4>
      <span className="msInnov">MS-Innov</span>
      <p>1 Rue Jacqueline Auriol</p>
      <p>90000 Belfort</p>
      </div>
    </div>
  );
}

export default App;
